import { VpdDataImportType } from "../../../graphql/types";
import { ColumnsType } from "antd/lib/table/interface";
import { Item } from "@design-system";

type ConfigurationOptions = {
  columns: ColumnsType<Item>;
};

export const Configuration = new Map<VpdDataImportType, ConfigurationOptions>([
  [
    VpdDataImportType.OrganisationalUnit,
    {
      columns: [
        {
          title: "Organisational Unit Name",
          dataIndex: "name",
        },
        {
          title: "Parent Organisational Unit",
          dataIndex: ["parent", "name"],
        },
        {
          title: "Reference",
          dataIndex: "externalReference",
          width: "20rem",
        },
      ],
    },
  ],
  [
    VpdDataImportType.OfficeLocation,
    {
      columns: [
        {
          title: "Office Name",
          dataIndex: "name",
        },
        {
          title: "Country Code",
          dataIndex: "countryCode",
          width: "15rem",
        },
        {
          title: "Reference",
          dataIndex: "externalReference",
          width: "20rem",
        },
      ],
    },
  ],
  [
    VpdDataImportType.FeeEarnerLevel,
    {
      columns: [
        {
          title: "Description",
          dataIndex: "description",
        },
        {
          title: "External Reference",
          dataIndex: "externalReference",
        },
      ],
    },
  ],
  [
    VpdDataImportType.FeeEarner,
    {
      columns: [
        {
          title: "Name",
          dataIndex: "name",
        },
        {
          title: "Cost Rate",
          dataIndex: "costRate",
        },
      ],
    },
  ],
  [
    VpdDataImportType.User,
    {
      columns: [
        {
          title: "User Name",
          dataIndex: "userName",
        },
        {
          title: "Display Name",
          dataIndex: "displayName",
        },
      ],
    },
  ],
  [
    VpdDataImportType.Client,
    {
      columns: [
        {
          title: "Name",
          dataIndex: "name",
        },
        {
          title: "Client Code",
          dataIndex: "externalReference",
        },
      ],
    },
  ],
  [
    VpdDataImportType.Rate,
    {
      columns: [
        {
          title: "Description",
          dataIndex: "description",
        },
        {
          title: "Amount",
          dataIndex: "amount",
        },
      ],
    },
  ],
  [
    VpdDataImportType.ExternalMatter,
    {
      columns: [
        {
          title: "Title",
          dataIndex: "title",
        },
        {
          title: "Status",
          dataIndex: "status",
        },
        {
          title: "Tax Status",
          dataIndex: "taxStatus",
        },
      ],
    },
  ],
  [
    VpdDataImportType.TimeEntry,
    {
      columns: [
        {
          title: "External Id",
          dataIndex: "externalId",
        },
        {
          title: "Hourly Charge Rate",
          dataIndex: "charge",
        },
        { title: "Duration in minutes", dataIndex: "durationInMinutes" },
      ],
    },
  ],
]);
